module.exports = __webpack_public_path__ + "static/media/25UNHCR4.3312ee14.jpg";